import { axiosClient } from '../clients/axiosClient.js';
import { AXIZ_API_ROUTES } from '../constants/apiRoutes.js';
import { logger } from '@digiwedge/logger';
/**
 * Creates a new sales order.
 * @param order - Order payload.
 * @returns Created order details.
 */
export const createOrder = async (order) => {
    try {
        const response = await axiosClient.post(AXIZ_API_ROUTES.SALES_ORDERS.CREATE, order);
        return response.data.result;
    }
    catch (error) {
        logger.error('Error creating order', { error });
        throw error;
    }
};
/**
 * Updates an existing sales order.
 * @param order - Order payload with ID.
 * @returns Updated order details.
 */
export const updateOrder = async (order) => {
    try {
        const response = await axiosClient.put(AXIZ_API_ROUTES.SALES_ORDERS.UPDATE, order);
        return response.data.result;
    }
    catch (error) {
        logger.error('Error updating order', { error });
        throw error;
    }
};
//# sourceMappingURL=orders.js.map